import React from 'react';

// Capitalize string
export function capitalize(s) {
  if (typeof s !== 'string') return 'Error: No String!';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// Line Breaks
export function addLineBreaks(string) {
  return string.split('\n').map((text, i) => (
    <React.Fragment key={`${i}`}>
      {text}
      <br />
    </React.Fragment>
  ));
}
